import { hashKey, useQuery } from '@tanstack/react-query';

import { Declaration, DeclarationStatus, IDeclarationsCriteria, SortDirection } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request, STORAGE_KEYS } from '@utils';
import { getStoredCriteria } from '../../../criteria.caching';

export const defaultDeclarationsCriteria: IDeclarationsCriteria = {
  filters: { searchQuery: '', fetchArchived: false, status: DeclarationStatus.ANALYSIS },
  pagination: { page: 1, size: 10, direction: 1, searchToken: '' },
  sorting: { field: 'messageInfo.batchId', direction: SortDirection.DESC },
};

export const getInitialCriteria = () => {
  const storedCriteria = getStoredCriteria(STORAGE_KEYS.COOKIES.LIST_DECLARATIONS_CRITERIA);
  return storedCriteria ?? defaultDeclarationsCriteria;
};

export const useDeclarations = (criteria: IDeclarationsCriteria) =>
  useQuery({
    queryKey: ['declarations', hashKey([criteria])],
    queryFn: async (): Promise<Declaration[]> => {
      const { filters, sorting, pagination } = criteria;
      try {
        const { data } = await request({
          path: `declarations/declaration-list`,
          method: 'POST',
          authenticate: true,
          dataObject: {
            criteria: {
              filters,
              sorting,
              pagination,
            },
          },
        });
        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarations');
      }
    },
  });
